import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import TransferModel from './transferModel.vue'
import ConcatModal from '@/components/TabsContacts/ofbu/editModal.vue'

const __default__ = { name: 'viewFooterBtn' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  workCode: {
    type: String
  },
  type: {
    type: String
  },
  loading: {
    type: Boolean
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  }
},
  emits: ['success'],
  setup(__props, { emit: __emit }) {

const transferModelRef = ref()
const concatModalRef = ref()
const router = useRouter()
const route = useRoute()
const emit = __emit
const props = __props
// 转移客户
const handleTransfer = () => {
  transferModelRef.value.toggle([{ cosId: route.query.cosId }])
}
// 新增联系人
const handleAddConcat = () => {
  concatModalRef.value.toggle()
}
// 新增访客计划
const hanleVisitor = () => {
  router.push({
    path: '/ofbu/visitorProgram/add',
    query: {
      saleChanceRefId: route.query.cosId
    }
  })
}
// 转移客户和新增联系人成功回调
const successPage = (tag: any) => {
  emit('success', tag)
}
// 新增跟进记录
const handleAddFollow = () => {
  router.push({
    path: '/ofbu/followUpRecord/add',
    query: {
      followRefId: route.query.cosId
    }
  })
}
// 新增商机
const handleAddBuss = () => {
  router.push({
    path: '/ofbu/business/add',
    query: {
      saleChanceRefId: route.query.cosId
    }
  })
}
//  编辑
const handleEdit = () => {
  let path = ''
  if (props.type === 'clients') {
    path = '/ofbu/clients/edit'
  } else if (props.type === 'potential') {
    path = '/ofbu/potential/edit'
  } else if (props.type === 'contract') {
    path = '/ofbu/contract/edit'
  }
  if (path) {
    router.push({
      path,
      query: {
        cosId: route.query.cosId
      }
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_cos_footer_button, {
      loading: __props.loading,
      hideOk: ""
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_a_button, { onClick: handleTransfer }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('btn.transferCustomer')), 1)
          ]),
          _: 1
        })), [
          [_directive_permission, __props.permissionPage?.transfer]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_a_button, { onClick: handleAddConcat }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('btn.addContact')), 1)
          ]),
          _: 1
        })), [
          [_directive_permission, __props.permissionPage?.concat_add]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_a_button, { onClick: handleAddFollow }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('btn.writeFollow')), 1)
          ]),
          _: 1
        })), [
          [_directive_permission, __props.permissionPage?.follow_add]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_a_button, { onClick: hanleVisitor }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('btn.addVisitor')), 1)
          ]),
          _: 1
        })), [
          [_directive_permission, __props.permissionPage?.visitor_add]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
          controlType: "none",
          workCode: __props.workCode,
          onClick: handleAddBuss
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('btn.addBussiess')), 1)
          ]),
          _: 1
        }, 8, ["workCode"])), [
          [_directive_permission, __props.permissionPage?.buss_add]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
          type: "primary",
          onClick: handleEdit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('btn.edit')), 1)
          ]),
          _: 1
        })), [
          [_directive_permission, __props.permissionPage?.edit]
        ])
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(TransferModel, {
      ref_key: "transferModelRef",
      ref: transferModelRef,
      onSuccess: _cache[0] || (_cache[0] = ($event: any) => (successPage('base')))
    }, null, 512),
    _createVNode(ConcatModal, {
      ref_key: "concatModalRef",
      ref: concatModalRef,
      onSuccess: _cache[1] || (_cache[1] = ($event: any) => (successPage('contact'))),
      contactRefId: _unref(route).query.cosId
    }, null, 8, ["contactRefId"])
  ], 64))
}
}

})